import { useMemo } from 'react';

import { useQuery } from '@apollo/client';

import GET_HOME_WIDGETS_POSITION_CONFIG_V5_QUERY from './graphql/get-widgets-position-config.v5.graphql';
import type { GetHomeWidgetsPositionConfigV5Query } from './graphql/types/GetHomeWidgetsPositionConfigV5Query';
import type { TTransformedItem } from './types';

type TUseHomeWidgetPositionsQueryArgs = {
  skip?: boolean;
};

export const useHomeWidgetPositionsQuery = (
  args?: TUseHomeWidgetPositionsQueryArgs,
) => {
  const { data, loading, error, refetch } =
    useQuery<GetHomeWidgetsPositionConfigV5Query>(
      GET_HOME_WIDGETS_POSITION_CONFIG_V5_QUERY,
      {
        context: {
          clientName: 'v5',
        },
        skip: args?.skip,
      },
    );

  const transformedData = useMemo<TTransformedItem[]>(() => {
    if (
      data?.foundation_home_user.get_widgets_config?.__typename ===
      'FoundationHomeWidgetsConfigPayload'
    ) {
      return data.foundation_home_user.get_widgets_config.widgets.map(
        widget => ({
          identifier: widget.identifier,
          span_config: {
            // Parse strings to numbers to handle both formats (future-proofing)
            lg:
              typeof widget.span_config.lg === 'string'
                ? parseInt(widget.span_config.lg, 10)
                : widget.span_config.lg,
            md:
              typeof widget.span_config.md === 'string'
                ? parseInt(widget.span_config.md, 10)
                : widget.span_config.md,
            sm:
              typeof widget.span_config.sm === 'string'
                ? parseInt(widget.span_config.sm, 10)
                : widget.span_config.sm,
          },
        }),
      );
    }
    return [];
  }, [data]);

  return {
    data: transformedData,
    loading,
    error,
    refetch,
  };
};
